<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'app',
  methods: {
    ...mapActions(['ping', 'getNewMessages']),
    connectionCheck() {
      if(document.getElementById('noConnection')) {
        this.$bvToast.hide('noConnection')
      }
      this.ping()
        .catch(() => {
          if(document.getElementById('noConnection') === null) {
            this.makeToast()
          }
        })
    },
    startConnectionCheck() {
      setInterval(() => {
        this.connectionCheck()
      }, 60 * 1000)
    },
    checkNewMessagesTimer() {
      setInterval(() => {
        this.getNewMessages()
      }, 30 * 60 * 1000)
    },
    makeToast() {
      this.$bvToast.toast('Es konnte keine Verbindung zum Senio Server hergestellt werden.', {
        id: 'noConnection',
        title: 'Keine Serververbindung',
        toaster: 'b-toaster-top-full',
        variant: 'danger',
        noAutoHide: false,
        autoHideDelay: 58000,
        solid: true
      });
    }
  },
  mounted () {
    this.connectionCheck()
    this.startConnectionCheck()
    // this.checkNewMessagesTimer()
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.top-space {
  margin-top: 8.5em;
}
</style>
